import React, { useEffect, useState, useCallback, useRef } from 'react';
import ArrowUpwardIcon from '@material-ui/icons/ArrowUpward';
import ArrowDownwardIcon from '@material-ui/icons/ArrowDownward';
import { useMemo } from 'react';
import TextField from '@material-ui/core/TextField';
import { useSelector, useDispatch } from "react-redux"
import * as AuthActions from "../../../store/actions/auth";
import { makeStyles, withStyles } from '@material-ui/core/styles';
import { IconButton } from '@material-ui/core';
import Grid from '@material-ui/core/Grid';
import MenuBook from '@material-ui/icons/MenuBook';
import Paper from '@material-ui/core/Paper';
import Table from '@material-ui/core/Table';
import TableBody from '@material-ui/core/TableBody';
import TableCell from '@material-ui/core/TableCell';
import TableContainer from '@material-ui/core/TableContainer';
import TableHead from '@material-ui/core/TableHead';
import TablePagination from '@material-ui/core/TablePagination';
import TableRow from '@material-ui/core/TableRow';
import { styled } from '@material-ui/core/styles';
import CancelIcon from '@material-ui/icons/Cancel';
import Searchbar from '../../admin_dashboard/patientOverviewFolder/patientSearchBar';
import ExerciseLibrary from '../../admin_dashboard/exerciseLibraryFolder/exerciseLibrary';
import SelectedPatientExercises from '../../admin_dashboard/singlePatientOverviewFolder/selectedPatientProgramBuilder';
import Box from '@material-ui/core/Box';
import Typography from '@material-ui/core/Typography';
import Link from '@material-ui/core/Link';
import Tooltip from '@material-ui/core/Tooltip';
import RemoveIcon from '@material-ui/icons/Remove';
import Star from '@material-ui/icons/Star';
import SelectedPatientProgram from '../../admin_dashboard/singlePatientOverviewFolder/selectedPatientProgram';
import axios from 'axios';
import DiscreteSliderAdmin from "../../user_dashboard/treatmentSession/rehabPhaseProgressBar_admin";
import DiscreteSliderDevelopment from '../../user_dashboard/treatmentSession/SymptomDevelopmentFeedback';
import CircularProgress from '@material-ui/core/CircularProgress';
import Dialog from '@material-ui/core/Dialog';
import DialogTitle from '@material-ui/core/DialogTitle';
import DialogContent from '@material-ui/core/DialogContent';
import DialogActions from '@material-ui/core/DialogActions';
import Button from '@material-ui/core/Button';
import List from '@material-ui/core/List';
import ListItem from '@material-ui/core/ListItem';
import Divider from '@material-ui/core/Divider';
import CareProviderPatientList from './careProviderPatientList';
import CareProviderStaffList from './careProviderStaffList';
import CareProviderDetails from './careProvider_details';
import Tabs from '@material-ui/core/Tabs';
import Tab from '@material-ui/core/Tab';

const StyledTableRow = styled(TableRow)({
  '& td, & th': {
    paddingTop: 8,
    paddingBottom: 8,
    paddingLeft: 8,
    paddingRight: 8,
  },'&:hover': {
    background: 'linear-gradient(90deg, #f5faff 60%, #e9f1f6ff 100%)',
  },
  '&.selected': {
    background: 'linear-gradient(90deg, #f5faff 60%, #e9f1f6ff 100%)',
  }
});


const GetJournalButton = withStyles({
    root: {
      boxShadow: "none",
      textTransform: "none",
      fontSize: 15,
      padding: "4px 8px",
      marginRight: 3,
      border: "0.5px solid",
      lineHeight: 0,
      backgroundColor: "transparent",
      borderColor: "transparent",
      color: "#002D55",
      "&:hover": {
          //boxShadow: "0 0 0 0.2rem rgba(0,123,255,.5)",
          backgroundColor: "white",
          borderColor: "orange"
      },
      "&:active": {
        //boxShadow: "0 0 0 0.2rem rgba(0,123,255,.5)",
        backgroundColor: "#FFFFFF",
        borderColor: "orange"
      },
      //"&:focus": {
      //  boxShadow: "0 0 0 0.2rem rgba(0,123,255,.5)"
      //}
    }
  })(IconButton);
  //logout
    //
    //


const useStyles = makeStyles((theme) => ({
  root: {
    width: '100%',
    padding: theme.spacing(0),
  },
  container: {
    maxHeight: 2000,
    marginBottom: "0.6%",
    padding: 0,
  },
  hover: {
    "&:hover": {
      backgroundColor: "lightgray",
    },
  },
  selected: {
    backgroundColor: "lightgray",
  },
  container2: {
    paddingTop: theme.spacing(0),
    paddingBottom: theme.spacing(0),
    paddingLeft: theme.spacing(0),
    paddingRight: theme.spacing(0),
  },
  orangeFocused: {
    '& .MuiOutlinedInput-root.Mui-focused .MuiOutlinedInput-notchedOutline': {
      borderColor: 'orange',
    },
    '& .MuiInputLabel-outlined.Mui-focused': {
      color: '#002D55', // brandcolor blue
    },
    '& .MuiInputLabel-outlined': {
      color: '#002D55', // brandcolor blue (default, not focused)
    },
    '& .MuiOutlinedInput-root:hover .MuiOutlinedInput-notchedOutline': {
      borderColor: 'orange', // hover effect
    },
  },
  responsiveText: {
    fontSize: 'clamp(0.755rem, 1.26vw, 0.90rem)'
  },
  responsiveText2: {
    fontSize: 'clamp(0.655rem, 1.06vw, 0.70rem)'
  },
  hideOnXs: {
    [theme.breakpoints.down('sm')]: {
      display: 'none'
    }
  },
  wideTooltip: {
    // allow wide tooltips (used for multi-column hover details)
    maxWidth: 'none',
    whiteSpace: 'normal',
    padding: 8,
  },
  TableRow: {
  '& td, & th': {
    paddingTop: 0,
    paddingBottom: 0,
    paddingLeft: 8,
    paddingRight: 8,
  }
}
}));

// Helper: format numbers to one decimal. If isPercent is true, append "%".
const fmt1 = (v, isPercent = false) => {
  if (v === null || v === undefined) return '-';
  const n = Number(v);
  if (Number.isNaN(n)) return '-';
  const rounded = Math.round(n * 10) / 10;
  return isPercent ? `${rounded}%` : `${rounded}`;
};

// Decide color for a change value. For pain/freq: decrease = good (green), little change = yellow, increase = bad (red).
// For function set invert=true to reverse (increase = good).
const trendColor = (change, isPercent = false, invert = false) => {
  if (change === null || change === undefined) return '#002D55';
  const n = Number(change);
  if (Number.isNaN(n)) return '#002D55';
  const abs = Math.abs(n);
  // thresholds: percent changes use 2 (% points), absolute numeric use 1 point
  const threshold = isPercent ? 2 : 1;
  if (abs <= threshold) return '#fbc02d'; // yellow (little/no change)
  const increased = n > 0; // positive means increase
  const isGood = invert ? increased : !increased;
  return isGood ? '#66bb6a' : '#f14747ff';
};



export default function PatientList(props) {
  const [isLoggedIn, setIsLoggedIn] = useState(useSelector(state => state.auth.isLoggedIn))
  const [isLoading, setIsLoading] = useState(false)
  const [token, _] = useState(useSelector(state => state.auth.token))
  const [isFetching, setIsFetching] = useState(false)
  const [diagnosis, setDiagnosis] = useState([])

  const [exercises, setExercises] = useState([])
  // Shared exercise library (fetch once and pass down)
  const [libraryExercises, setLibraryExercises] = useState([]);
  const [libraryLoaded, setLibraryLoaded] = useState(false);
  // Store all phases for the selected patient
  const [patientPhases, setPatientPhases] = useState([])
  const [current_exercise_ind, setCurrent_exercise_ind] = useState(0)
  const [phases, setPhases] = useState([]);
  const [profiles, setProfiles] = useState([])
  const [careProviders, setCareProviders] = useState([]);
  const [selectedCareProvider, setSelectedCareProvider] = useState(null);
  const [viewProviderPatients, setViewProviderPatients] = useState(false);
  const [cpPatients, setCpPatients] = useState([]);
  const [cpStaff, setCpStaff] = useState([]);
  const [providerTab, setProviderTab] = useState(0);
  const [selectedPatient, setSelectedPatient] = useState(null);
  const [selectedPhaseId, setSelectedPhaseId] = useState('');

  // Add: per-patient metrics cache + fetch helpers
const [patientMetrics, setPatientMetrics] = useState({}); // { [userId]: { baseline, improvements, fetchedAt } }
const [loadingMetrics, setLoadingMetrics] = useState({}); // { [userId]: boolean }

/** Fetch baseline + improvements for a specific patient (uses path-style endpoints added in backend) */
const fetchPatientMetrics = async (userId, diagnosisIdentifier) => {
  if (!userId || !diagnosisIdentifier) return null;
  // return cached if fresh (5 min)
  const cached = patientMetrics[userId];
  if (cached && (Date.now() - (cached.fetchedAt || 0) < 1000 * 60 * 5)) return cached;
  if (loadingMetrics[userId]) return null;
  setLoadingMetrics(prev => ({ ...prev, [userId]: true }));
  try {
    const headers = { 'Authorization': `Token ${token}`, 'Accept': 'application/json' };
    const baseUrl = 'https://api.virtus-one.com';
    const diag = encodeURIComponent(diagnosisIdentifier);

    // Fetch baseline + improvements (server-side improvements endpoint will prefer stored DB value and only compute as fallback)
    const [baseRes, impRes] = await Promise.all([
      fetch(`${baseUrl}/question-handler/baseline/${diag}/${userId}/?qtypes=selfRatedPain,selfRatedFunction`, { headers }),
      fetch(`${baseUrl}/question-handler/improvements/${diag}/${userId}/`, { headers })
    ]);

    const baseline = baseRes && baseRes.ok ? await baseRes.json() : null;
    const improvements = impRes && impRes.ok ? await impRes.json() : null;

    const payload = { baseline, improvements, fetchedAt: Date.now() };
    setPatientMetrics(prev => ({ ...prev, [userId]: payload }));
    return payload;
  } catch (err) {
    console.error('fetchPatientMetrics', err);
    return null;
  } finally {
    setLoadingMetrics(prev => ({ ...prev, [userId]: false }));
  }
};

/** helpers to extract function info from payloads */
const extractFunctionFromImprovements = (improvements) => {
  if (!improvements || !Array.isArray(improvements.comparisons)) return null;
  const comp = improvements.comparisons.find(c => {
    const id = (c.question_identifier || '').toLowerCase();
    return id.includes('selfratedfunction') || id.includes('psfs') || id.includes('function');
  });
  if (!comp) return null;
  return {
    
    followup_value: (comp.followup_value !== undefined ? comp.followup_value : null),
    percent_change: (comp.percent_change !== undefined ? comp.percent_change : null),
    absolute_change: (comp.absolute_change !== undefined ? comp.absolute_change : null)
  };
};

const extractFunctionFromBaseline = (baselinePayload) => {
  if (!baselinePayload || !baselinePayload.baselines) return null;
  const func = baselinePayload.baselines.selfRatedFunction;
  if (!func || !Array.isArray(func.items) || func.items.length === 0) return null;
  const it = func.items[0];
  return {
    baseline_text: it.text_value || null,
    numeric_value: (it.numeric_value !== undefined ? it.numeric_value : (it.answerId ? parseInt(it.answerId, 10) || null : null))
  };
};

// Extract NPS information from improvements payload. Matches identifiers like 'nps', 'selfrated_nps', 'selfratednps'
const extractNPSFromImprovements = (improvements) => {
  if (!improvements || !Array.isArray(improvements.comparisons)) return null;
  const comp = improvements.comparisons.find(c => {
    const id = (c.question_identifier || '').toLowerCase();
    return id.includes('nps') || id.includes('selfrated_nps') || id.includes('selfratednps') || id.includes('netpromoter');
  });
  if (!comp) return null;
  return {
    baseline_value: (comp.baseline_value !== undefined ? comp.baseline_value : null),
    followup_value: (comp.followup_value !== undefined ? comp.followup_value : null),
    percent_change: (comp.percent_change !== undefined ? comp.percent_change : null),
    absolute_change: (comp.absolute_change !== undefined ? comp.absolute_change : null),
    baseline_text: comp.baseline_text || null,
    followup_text: comp.followup_text || null
  };
};

// Extract NPS from baseline payload. Prefer entries under selfRatedFunction/selfRated_NPS; otherwise scan baseline sections for numeric values in 0-10 range.
const extractNPSFromBaseline = (baselinePayload) => {
  if (!baselinePayload || !baselinePayload.baselines) return null;
  // First try the selfRatedFunction section (NPS may be stored here after mapping)
  const srFunc = baselinePayload.baselines.selfRatedFunction;
  if (srFunc && Array.isArray(srFunc.items) && srFunc.items.length) {
    const it = srFunc.items[0];
    // If the numeric value looks like an NPS (0-10) use it
    const maybe = (it.numeric_value !== undefined && it.numeric_value !== null) ? Number(it.numeric_value) : (it.answerId ? parseInt(it.answerId, 10) : null);
    if (maybe !== null && !Number.isNaN(maybe) && maybe >= 0 && maybe <= 10) {
      return { numeric_value: maybe, baseline_text: it.text_value || null };
    }
  }
  // Otherwise scan all baseline sections for a numeric value that looks like an NPS (0-10)
  const keys = Object.keys(baselinePayload.baselines || {});
  for (const k of keys) {
    const b = baselinePayload.baselines[k];
    if (b && Array.isArray(b.items) && b.items.length) {
      const it = b.items[0];
      const val = (it.numeric_value !== undefined && it.numeric_value !== null) ? Number(it.numeric_value) : (it.answerId ? parseInt(it.answerId, 10) : null);
      if (val !== null && !Number.isNaN(val) && val >= 0 && val <= 10) {
        return { numeric_value: val, baseline_text: it.text_value || null };
      }
    }
  }
  return null;
};

// Extract a numeric pain baseline value from baseline payloads.
// Returns a number (0-100 scale expected) or null when not found.
const extractPainFromBaseline = (baselinePayload) => {
  if (!baselinePayload || !baselinePayload.baselines) return null;
  // Prefer explicit selfRatedPain baseline if present
  const pain = baselinePayload.baselines.selfRatedPain;
  if (pain && Array.isArray(pain.items) && pain.items.length) {
    const it = pain.items[0];
    if (it && it.numeric_value !== undefined && it.numeric_value !== null) return it.numeric_value;
    if (it && it.answerId) return parseInt(it.answerId, 10) || null;
  }
  // Fallback: search any baseline section for a numeric value
  const keys = Object.keys(baselinePayload.baselines || {});
  for (const k of keys) {
    const b = baselinePayload.baselines[k];
    if (b && Array.isArray(b.items) && b.items.length) {
      const it = b.items[0];
      if (it && it.numeric_value !== undefined && it.numeric_value !== null) return it.numeric_value;
      if (it && it.answerId) return parseInt(it.answerId, 10) || null;
    }
  }
  return null;
};

// When 'profiles' changes (initial load), fetch metrics and merge into profiles
useEffect(() => {
  if (!profiles || !Array.isArray(profiles)) return;
  profiles.forEach(async (p) => {
    const uid = p.user_id || p.id || (p.user && p.user.id);
    if (!uid) return;
    if (p._metrics || patientMetrics[uid]) return; // already merged / cached
    const diagId = (p.diagnosis && p.diagnosis.length && p.diagnosis[0].identifier) ? p.diagnosis[0].identifier : (p.diagnosisIdentifier || null);
    if (!diagId) return;
    const metrics = await fetchPatientMetrics(uid, diagId);
    if (!metrics) return;
    const funcImp = extractFunctionFromImprovements(metrics.improvements);
    const funcBase = extractFunctionFromBaseline(metrics.baseline);
    const merged = {
      baseline_text: (funcImp && funcImp.baseline_text) || (funcBase && funcBase.baseline_text) || null,
      latest_function: (funcImp && funcImp.followup_value !== null && funcImp.followup_value !== undefined) ? funcImp.followup_value : (funcBase && funcBase.numeric_value !== null ? funcBase.numeric_value : null),
      function_percent: funcImp && funcImp.percent_change !== null && funcImp.percent_change !== undefined ? funcImp.percent_change : null,
      baseline_payload: metrics.baseline,
      improvements_payload: metrics.improvements
    };
    // merge into profiles safely
    setProfiles(prev => prev.map(r => ( (r.user_id || r.id || (r.user && r.user.id)) === uid ? { ...r, _metrics: merged } : r )));
  });
  // eslint-disable-next-line react-hooks/exhaustive-deps
}, [profiles]);
  
  // Safe setter: only update if different
  const safeSetSelectedPhaseId = useCallback((newId) => {
    setSelectedPhaseId(prev => (prev !== newId ? newId : prev));
  }, []);
  // Track previous selectedPatient user_id
  const prevUserIdRef = useRef(null);

  // Combined effect: fetch phases and set selectedPhaseId only after phases are loaded
  useEffect(() => {
    let isMounted = true;
    if (!selectedPatient || !selectedPatient.user_id) {
      setPatientPhases([]);
      setSelectedPhaseId('');
      prevUserIdRef.current = null;
      return;
    }
    // Fetch phases for selected patient
    fetch(`https://api.virtus-one.com/treatment/phases/patient/${selectedPatient.user_id}/`, {
      headers: {
        "Authorization": `Token ${token}`,
        Accept: 'application/json'
      }
    })
      .then(response => response.ok ? response.json() : Promise.reject("Failed to fetch phases"))
      .then(data => {
        if (!isMounted) return;
        setPatientPhases(data.phases || []);
        // Set selectedPhaseId logic
        if (!data.phases || data.phases.length === 0) {
          setSelectedPhaseId('');
          return;
        }
        // If user id changed, always reset selectedPhaseId to current phase
        if (prevUserIdRef.current !== selectedPatient.user_id) {
          let currentPhaseName = '';
          let currentPhaseIndex = undefined;
          if (selectedPatient.diagnosis && selectedPatient.diagnosis.length > 0) {
            const activeDiagnosis = selectedPatient.diagnosis[selectedPatient.diagnosis.length - 1];
            if (activeDiagnosis && activeDiagnosis.name) {
              currentPhaseName = activeDiagnosis.name;
            }
            if (typeof activeDiagnosis?.index === 'number') {
              currentPhaseIndex = activeDiagnosis.index;
            }
          }
          let match = null;
          if (currentPhaseName) {
            match = data.phases.find(phase =>
              phase.name && phase.name.toLowerCase().startsWith(currentPhaseName.toLowerCase())
            );
          }
          if (!match && typeof currentPhaseIndex === 'number') {
            match = data.phases.find((phase, idx) => idx === currentPhaseIndex || phase.index === currentPhaseIndex);
          }
          if (match) {
            setSelectedPhaseId(match.id);
          } else {
            let currentPhaseId = '';
            if (selectedPatient.diagnosis && selectedPatient.diagnosis.length > 0) {
              const activeDiagnosis = selectedPatient.diagnosis[selectedPatient.diagnosis.length - 1];
              if (activeDiagnosis && activeDiagnosis.phase_id) {
                currentPhaseId = activeDiagnosis.phase_id;
              } else if (activeDiagnosis && activeDiagnosis.current_phase_id) {
                currentPhaseId = activeDiagnosis.current_phase_id;
              }
            }
            if (currentPhaseId) {
              setSelectedPhaseId(currentPhaseId);
            }
          }
          prevUserIdRef.current = selectedPatient.user_id;
          return;
        }
        // Otherwise, do as before: only set if not already set
        if (!selectedPhaseId) {
          let currentPhaseName = '';
          let currentPhaseIndex = undefined;
          if (selectedPatient.diagnosis && selectedPatient.diagnosis.length > 0) {
            const activeDiagnosis = selectedPatient.diagnosis[selectedPatient.diagnosis.length - 1];
            if (activeDiagnosis && activeDiagnosis.name) {
              currentPhaseName = activeDiagnosis.name;
            }
            if (typeof activeDiagnosis?.index === 'number') {
              currentPhaseIndex = activeDiagnosis.index;
            }
          }
          let match = null;
          if (currentPhaseName) {
            match = data.phases.find(phase =>
              phase.name && phase.name.toLowerCase().startsWith(currentPhaseName.toLowerCase())
            );
          }
          if (!match && typeof currentPhaseIndex === 'number') {
            match = data.phases.find((phase, idx) => idx === currentPhaseIndex || phase.index === currentPhaseIndex);
          }
          if (match) {
            setSelectedPhaseId(match.id);
          } else {
            let currentPhaseId = '';
            if (selectedPatient.diagnosis && selectedPatient.diagnosis.length > 0) {
              const activeDiagnosis = selectedPatient.diagnosis[selectedPatient.diagnosis.length - 1];
              if (activeDiagnosis && activeDiagnosis.phase_id) {
                currentPhaseId = activeDiagnosis.phase_id;
              } else if (activeDiagnosis && activeDiagnosis.current_phase_id) {
                currentPhaseId = activeDiagnosis.current_phase_id;
              }
            }
            if (currentPhaseId) {
              setSelectedPhaseId(currentPhaseId);
            }
          }
        }
      })
      .catch(error => {
        if (!isMounted) return;
        setPatientPhases([]);
        setSelectedPhaseId('');
      });
    return () => { isMounted = false; };
  }, [selectedPatient, token, selectedPhaseId]);

  // 3. When selectedPhaseId changes, fetch exercises for that phase
  useEffect(() => {
    console.log('[DEBUG] selectedPhaseId changed:', selectedPhaseId);
    if (selectedPhaseId) {
      fetchExercisesForPhase(selectedPhaseId);
    }
  }, [selectedPhaseId]);
  let didCancel = false;
  const classes = useStyles();
  const [open, setOpen] = React.useState(true);
  const handleDrawerOpen = () => {
    setOpen(true);
  };
  const handleDrawerClose = () => {
    setOpen(false);
  };
  
  const dispatch = useDispatch();
  // Removed selectedProfile and selectedProfileId. Use only selectedPatient.
  const [searchInput, setSearchInput] = useState("");
  
  const handleSearch = (e) => {
    const search = e.target.value.toLowerCase()
    setSearchInput(search)
  }
  
  useEffect(() => {
    if (!isLoggedIn) {
      window.location.replace("/");
    }
  }, [isLoggedIn, setIsLoggedIn]);


  const handleGetJournalButtonClick = (user_id) => {
    console.log(typeof user_id)
    console.log(user_id)
    fetch(`https://api.virtus-one.com/journal/selectedPatient/${user_id}`, {
        headers: {
            "Authorization": `Token ${token}`,
            "Content-Type": "application/json",
        },
        method: "GET",
    })
    .then((response) => response.blob())
    .then((blob) => {
        const url = window.URL.createObjectURL(new Blob([blob]));
        const link = document.createElement("a");
        link.href = url;
        link.setAttribute("download", "filename.pdf");
        document.body.appendChild(link);
        link.click();
    })
};
const [previewExercises, setPreviewExercises] = useState([]);

const handleAddExercise = (exercise) => {
  // Use a unique identifier, fallback to title if no id
  const uniqueId = exercise.id || exercise.identifier || exercise.title;
  if (previewExercises.some(e => (e.id || e.identifier || e.title) === uniqueId)) return;
  // Set default index
  const index = exercises.length + previewExercises.length + 1;
  setPreviewExercises(prev => [...prev, { ...exercise, index }]);
};

const handleRemovePreviewExercise = (exercise) => {
  const uniqueId = exercise.id || exercise.identifier || exercise.title;
  setPreviewExercises(prev => prev.filter(e => (e.id || e.identifier || e.title) !== uniqueId));
};

//Fetches user data for each user in the database
const fetchUserTableData = async () => {
  if (didCancel) return;
  const response = await fetch("https://api.virtus-one.com/treatment/getUserTable/", {
    headers: {
      "Authorization": `Token ${token}`
    },
    method: "GET",
  });
  if (response.ok) {
    const data = await response.json();
    setProfiles(data)
    console.log(data)
  } else {
    alert("ERROR")
  }
  setIsLoading(false)
}

useEffect(() => {
  setIsLoading(true)
  fetchUserTableData()
  let didCancel = false;
  return () => {
    didCancel = true;
  };
}, []);

// Fetch care providers list on mount
useEffect(() => {
  if (!token) return;
  const fetchCareProviders = async () => {
    try {
      setIsFetching(true);
      const res = await fetch('https://api.virtus-one.com/profile/careproviders/', {
        headers: { 'Authorization': `Token ${token}`, Accept: 'application/json' }
      });
      if (!res.ok) throw new Error('Failed to fetch care providers');
      const data = await res.json();
      // endpoint returns { care_providers: [...] } or an array directly
      const list = Array.isArray(data) ? data : (data.care_providers || []);
      setCareProviders(list);
    } catch (err) {
      console.error('fetchCareProviders', err);
      setCareProviders([]);
    } finally {
      setIsFetching(false);
    }
  };
  fetchCareProviders();
}, [token]);

// Fetch exercise library once and share with children to avoid duplicate network calls
useEffect(() => {
  let cancelled = false;
  if (!token) return;
  const fetchLibrary = async () => {
    try {
      const res = await fetch('https://api.virtus-one.com/treatment/exercise/', {
        headers: { Authorization: `Token ${token}` },
        method: 'GET'
      });
      if (!res.ok) {
        console.error('Failed to fetch exercise library', res.status);
        return;
      }
      const data = await res.json();
      if (!cancelled) {
        setLibraryExercises(data.exercises || []);
        setLibraryLoaded(true);
      }
    } catch (err) {
      if (!cancelled) console.error('fetchLibrary error', err);
    }
  };
  fetchLibrary();
  return () => { cancelled = true; };
}, [token]);

// Fetch all phases for the selected patient (using new endpoint with correct phase IDs)
const fetchPhasesForPatient = async (selectedPatient) => {
  if (!selectedPatient || !selectedPatient.user_id) {
    setPatientPhases([]);
    return;
  }
  fetch(`https://api.virtus-one.com/treatment/phases/patient/${selectedPatient.user_id}/`, {
    headers: {
      "Authorization": `Token ${token}`,
      Accept: 'application/json'
    }
  })
    .then(response => response.ok ? response.json() : Promise.reject("Failed to fetch phases"))
    .then(data => {
      setPatientPhases(data.phases || []);
    })
    .catch(error => {
      setPatientPhases([]);
    });
};



  useEffect(() => {
    // Only set selectedPhaseId if it is not already set (undefined or empty string)
    if (!selectedPatient || !selectedPatient.user_id) {
      setSelectedPhaseId('');
      return;
    }
    if (!patientPhases || patientPhases.length === 0) {
      setSelectedPhaseId('');
      return;
    }
    if (!selectedPhaseId) {
      let currentPhaseId = '';
      if (selectedPatient.diagnosis && selectedPatient.diagnosis.length > 0) {
        const activeDiagnosis = selectedPatient.diagnosis[selectedPatient.diagnosis.length - 1];
        if (activeDiagnosis && activeDiagnosis.phase_id) {
          currentPhaseId = activeDiagnosis.phase_id;
        } else if (activeDiagnosis && activeDiagnosis.current_phase_id) {
          currentPhaseId = activeDiagnosis.current_phase_id;
        }
      }
      // Do NOT fallback to first phase if no currentPhaseId
      // Only set if currentPhaseId is found
      if (currentPhaseId) {
        setSelectedPhaseId(currentPhaseId);
      }
    }
  }, [selectedPatient, patientPhases]);

// Fetch exercises for a specific phase (by phase id)
const fetchExercisesForPhase = useCallback(async (phaseId) => {
  if (!selectedPatient || !patientPhases.length) return;
  // Only allow valid phaseId
  const phaseObj = patientPhases.find(p => p.id === phaseId);
  if (!phaseObj) {
    alert("Selected phase does not exist for this patient.");
    return;
  }
  const userId = selectedPatient.user_id;
  fetch(`https://api.virtus-one.com/treatment/exercises/phase/${phaseId}/${userId}/`, {
    headers: {
      "Authorization": `Token ${token}`,
      Accept: 'application/json'
    }
  })
    .then(response => response.ok ? response.json() : Promise.reject("Failed to fetch phase exercises"))
    .then(data => {
      setExercises(data.exercises || []);
    })
    .catch(error => {
      setExercises([]);
    });
}, [selectedPatient, patientPhases, token]);

// Parent helper: refresh exercises for the selected patient. Child can call this
// after saving to make the parent re-fetch and update `exercises` state.
const fetchExercisesForPatient = useCallback(async () => {
  if (!selectedPatient || !selectedPatient.user_id) {
    setExercises([]);
    return;
  }
  // Prefer explicit selected phase
  if (selectedPhaseId) {
    await fetchExercisesForPhase(selectedPhaseId);
    return;
  }
  // Fallback: use first patientPhase if available
  const fallbackPhase = (patientPhases && patientPhases.length) ? patientPhases[0].id : null;
  if (fallbackPhase) {
    await fetchExercisesForPhase(fallbackPhase);
    return;
  }
  // Nothing to fetch
  setExercises([]);
}, [selectedPatient, selectedPhaseId, patientPhases, fetchExercisesForPhase]);


const getCurrentPhase = () => {
  if (!selectedPatient || !selectedPatient.diagnosis || selectedPatient.diagnosis.length === 0) return null;
  // Get the phase with the highest progress
  const phase = selectedPatient.diagnosis.reduce((max, phase) => (phase.progress > (max?.progress || 0) ? phase : max), null);
  if (phase) {
    // Try to find the matching phase in patientPhases to get the index
    const matchingPhase = patientPhases.find(p => p.name === phase.name);
    const result = {
      progress: phase.progress,
      name: phase.name,
      index: matchingPhase ? matchingPhase.index : undefined
    };
    console.log('[PatientList] currentPhase (progress, name, index):', result);
    return result;
  }
  return null;
};


useEffect(() => {
  if (selectedPatient && selectedPatient.diagnosis) {
    console.log('Selected patient diagnosis:', selectedPatient.diagnosis);
    console.log('Patient phases:', patientPhases);
    // Try to log phase index for each diagnosis
    selectedPatient.diagnosis.forEach((phase) => {
      const matchingPhase = patientPhases.find(p => p.id === phase.id);
      console.log('Diagnosis phase:', phase, 'Matching patientPhase:', matchingPhase);
      if (matchingPhase) {
        console.log('Phase index:', matchingPhase.index);
      }
    });
  }
}, [selectedPatient, patientPhases]);

const CareProviderList = ({profiles, diagnosis, phases, exercises, selectedPatient, setSelectedPatient}) => {
  const classes = useStyles();
  const [searchInput, setSearchInput] = useState("");
  const filteredProfiles = useMemo(() => {
      return profiles.filter(profile => {
        const name = `${profile.first_name} ${profile.last_name}`.toLowerCase();
        return name.includes(searchInput.toLowerCase());
      });
    }, [profiles, searchInput]);


  // Inline style for the container holding the search bar and selected patient input
  const searchBarRowStyle = {
    display: 'flex',
    alignItems: 'center',
    gap: 8,
    marginBottom: 8
  };

  return (
    <div>
      <Paper style={{ marginBottom: 12, padding: 12 }}>
        <Typography variant="h6" style={{ marginBottom: 8 }}>Care Providers</Typography>
        {isFetching ? <CircularProgress size={20} /> : (
          <Table size="small">
            <TableHead>
              <TableRow>
                <TableCell><b>Name</b></TableCell>
                <TableCell><b>Type</b></TableCell>
                <TableCell><b>City</b></TableCell>
                <TableCell><b>Avg NPS</b></TableCell>
                <TableCell><b>Specialties</b></TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {careProviders.map((cp) => (
                <StyledTableRow key={cp.id}
                  onClick={() => { try { setSelectedCareProvider(cp); } catch(e){} }}
                  onDoubleClick={() => {
                    // compute patients & staff from already-fetched profiles
                    const patients = profiles.filter(p => {
                      try {
                        // several possible shapes
                        if (p.care_provider && (p.care_provider.id === cp.id || p.care_provider === cp.id)) return true;
                        if (p.profile && (p.profile.care_provider === cp.id || (p.profile.care_provider && p.profile.care_provider.id === cp.id))) return true;
                        if (p.assigned_care_provider_id && p.assigned_care_provider_id === cp.id) return true;
                        return false;
                      } catch (e) { return false; }
                    });
                    const staff = profiles.filter(p => {
                      try {
                        const isStaff = p.is_staff || p.role_type || p.role; // loose check
                        const linked = (p.care_provider && (p.care_provider.id === cp.id || p.care_provider === cp.id)) ||
                                     (p.profile && (p.profile.care_provider === cp.id || (p.profile.care_provider && p.profile.care_provider.id === cp.id)));
                        return !!isStaff && !!linked;
                      } catch (e) { return false; }
                    });
                    setCpPatients(patients);
                    setCpStaff(staff);
                    setSelectedCareProvider(cp);
                    // show the dedicated patients list view for this care provider
                    setViewProviderPatients(true);
                  }}
                  style={selectedCareProvider && (selectedCareProvider.id === cp.id || String(selectedCareProvider.id) === String(cp.id)) ? { backgroundColor: 'lightgray' } : {}}
                >
                  <TableCell>{cp.name_business || cp.name || cp.name_business}</TableCell>
                  <TableCell>{cp.care_provider_type || cp.type || '-'}</TableCell>
                  <TableCell>{cp.city || '-'}</TableCell>
                  <TableCell>{cp.avg_nps !== undefined && cp.avg_nps !== null ? fmt1(cp.avg_nps) : '-'}</TableCell>
                  <TableCell>{(cp.specialties && cp.specialties.join) ? cp.specialties.join(', ') : ''}</TableCell>
                </StyledTableRow>
              ))}
            </TableBody>
          </Table>
        )}
      </Paper>

      {viewProviderPatients && selectedCareProvider ? (
        <div>
          <Tabs
            value={providerTab}
            onChange={(e, v) => setProviderTab(v)}
            indicatorColor="primary"
            textColor="primary"
            aria-label="Care provider tabs"
          >
            <Tab label="Patients" />
            <Tab label="Staff" />
            <Tab label="Details" />
          </Tabs>

          <Box hidden={providerTab !== 0} mt={2}>
            <CareProviderPatientList
              careProvider={selectedCareProvider}
              profiles={profiles}
              onClose={() => setViewProviderPatients(false)}
            />
          </Box>

          <Box hidden={providerTab !== 1} mt={2}>
            <CareProviderStaffList
              careProvider={selectedCareProvider}
              profiles={profiles}
              onBack={() => setViewProviderPatients(false)}
            />
          </Box>

          <Box hidden={providerTab !== 2} mt={2}>
            <CareProviderDetails
              careProviderId={selectedCareProvider && (selectedCareProvider.id || selectedCareProvider.pk)}
              careProvider={selectedCareProvider}
              onBack={() => setViewProviderPatients(false)}
            />
          </Box>
        </div>
      ) : null}
    </div>
  );
}

 

return (
          <CareProviderList profiles={profiles} diagnosis={diagnosis} phases={phases} exercises={exercises} selectedPatient={selectedPatient} setSelectedPatient={setSelectedPatient} />
);

}
